import history from '../history'

// ------------------------------------
// Constants
// ------------------------------------
export const LOCATION_CHANGE = 'LOCATION_CHANGE'

// ------------------------------------
// Actions
// ------------------------------------
export const locationChange = (location = '/', action = 'PUSH') => {
  return {
    type: LOCATION_CHANGE,
    payload: { ...location, action }
  }
}

// ------------------------------------
// Specialized Action Creator
// ------------------------------------
export const updateLocation = ({ dispatch }) => {
  return (nextLocation, action) => dispatch(locationChange(nextLocation, action))
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = history.location
export default function locationReducer(state = initialState, action) {
  return action.type === LOCATION_CHANGE ? action.payload : state
}
